module.exports = __webpack_public_path__ + "media/images/blue-sunburst-2d24f49541d4503b0d9c1a296a4f71b7.png";